import React from 'react'

// These render conditionally after an action (submit, save, upgrade), so they
// are live regions: without role="alert" a screen reader user submits a form,
// gets an error, and hears nothing at all (WCAG 3.3.1, 4.1.3).
export function ErrorAlert({ message }) {
  if (!message) return null
  return (
    <div
      role="alert"
      className="rounded-lg bg-red-50 border border-red-200 p-4 text-sm text-red-700"
    >
      {message}
    </div>
  )
}

export function SuccessAlert({ message }) {
  if (!message) return null
  return (
    <div
      role="status"
      className="rounded-lg bg-green-50 border border-green-200 p-4 text-sm text-green-700"
    >
      {message}
    </div>
  )
}
